import './PeriscopeTag.scss';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { SonarRecord } from '@ui/records';
import { SonarTagDisplay } from '@ui/tags/SonarTag';
import { useTagReference } from '@hooks';
import React, { useCallback } from 'react';
export const PeriscopeTag = ({ onTagClick, tagId }) => {
    const tag = useTagReference(tagId);
    const handleClick = useCallback(() => {
        if (onTagClick) {
            onTagClick(tag);
        }
    }, [tag, onTagClick]);
    const info = React.createElement("div", { className: 'periscope-tag' },
        React.createElement(SonarTagDisplay, { showDescription: true, tagId: tagId }));
    return (React.createElement(SonarRecord, { name: info, onClick: handleClick, sonarObjectId: null, sonarObjectType: SonarObjectType.SonarTag }));
};
